import { Award, CalendarCheck, Cpu, FolderCheck, PhoneCall } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { MapleMark } from "@/components/MapleMark";
import { WHY } from "@/config/site";

const ICONS = {
  award: Award,
  phone: PhoneCall,
  maple: MapleMark,
  cpu: Cpu,
  calendar: CalendarCheck,
  folder: FolderCheck,
};

export default function WhyPostings() {
  return (
    <section id="why" className="bg-surface py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>Why Postings</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-cabinet text-4xl font-extrabold tracking-tighter sm:text-5xl">
              Why businesses choose Postings.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {WHY.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <Reveal key={w.title} delay={(i % 3) * 0.07}>
                <div className="flex gap-4" data-testid={`why-item-${i}`}>
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl border border-ink/5 bg-white text-brand shadow-subtle">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-cabinet text-lg font-bold tracking-tight">{w.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{w.text}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
